import { render, staticRenderFns } from "./BaseLinkBlock.vue?vue&type=template&id=5f3516e1&scoped=true&"
import script from "./BaseLinkBlock.vue?vue&type=script&lang=js&"
export * from "./BaseLinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseLinkBlock.vue?vue&type=style&index=0&id=5f3516e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3516e1",
  null
  
)

export default component.exports